import type { BudgetOption } from '@modules/build-hub-creator/api/types';
import { BUDGET_NOT_SPECIFIED } from '@modules/build-hub/utils/format-build-hub-attributes';

export type { BudgetOption };

export const BUILD_HUB_TITLE_MAX_LENGTH = 60;
export const BUILD_HUB_TITLE_MAX_LENGTH_WARNING = 20;
export const BUILD_HUB_TITLE_MAX_LENGTH_WARNING_THRESHOLD = 10;
export const CUSTOM_BUDGET_OPTION: BudgetOption = {
    key: 'budget_custom',
    label: 'Custom Budget',
};
export const DEFAULT_BUDGET_OPTION: BudgetOption = {
    key: 'budget_unknown',
    label: BUDGET_NOT_SPECIFIED,
    min: 0,
    max: 0,
};
export const BUDGET_OPTIONS: BudgetOption[] = [
    DEFAULT_BUDGET_OPTION,
    {
        key: 'budget_under_50k',
        label: 'Under $50k',
        min: 0,
        max: 49999,
    },
    { key: 'budget_50k_100k', label: '$50k - $100k', min: 50000, max: 100000 },
    {
        key: 'budget_100k_250k',
        label: '$100k - $250k',
        min: 100001,
        max: 250000,
    },
    {
        key: 'budget_250k_500k',
        label: '$250k - $500k',
        min: 250001,
        max: 500000,
    },
    { key: 'budget_500k_1m', label: '$500k - $1m', min: 500001, max: 1000000 },
    { key: 'budget_1m_2m', label: '$1m - $2m', min: 1000001, max: 2000000 },
    { key: 'budget_2m_3m', label: '$2m - $3m', min: 2000001, max: 3000000 },
    { key: 'budget_3m_5m', label: '$3m - $5m', min: 3000001, max: 5000000 },
    { key: 'budget_5m_plus', label: '$5m+', min: 5000001 },
    CUSTOM_BUDGET_OPTION,
];
